import { Flex, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Content, EditButtonLink } from '@/core/components';

import { Discipline } from './model/DisciplineTypes';

interface DisciplineViewProps {
  discipline: Discipline;
}

export function DisciplineView(props: DisciplineViewProps) {
  const { t } = useTranslation();

  const { discipline } = props;
  const { name } = discipline;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Text fw="500">{name}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              {/*<DisciplineDeleteButton disciplineId={discipline.id} /> TODO ENABLE AFTER SECURITY CHECK*/}
            </Group>
          </Flex>
        </Stack>
      </Content>

      <Content type="full">
        <Text fw="500">{t('disciplines.form.fields.department')}</Text>
        <Group>{discipline.department.name}</Group>
      </Content>

      {discipline.headOfDiscipline && (
        <Content type="full">
          <Text fw="500">{t('disciplines.form.fields.headOfDiscipline')}</Text>
          <Group>{discipline.headOfDiscipline.email}</Group>
          <Group>
            {discipline.headOfDiscipline.firstName} {discipline.headOfDiscipline.lastName}
          </Group>
        </Content>
      )}
    </Stack>
  );
}
